var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iCanLoad)?_c('div',{attrs:{"id":"sgConfig"}},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v("Configuration Details")]),_c('div',{staticClass:"configurationDetails"},[_c('CRDSummary',{attrs:{"crd":_vm.crd,"kind":"SGConfig","details":true}})],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }